<template>
  <div>
    <h1 class="pa-3">CONTACT STORE APPROVE</h1>
    <v-layout row>
      <!-- <v-flex xs8>
        <v-spacer></v-spacer>
      </v-flex>-->
      <v-flex xs12>
        <div style="background-color: #f2f2f2; padding: 10px">
          <v-layout wrap justify-center>
            <v-flex xs12 class="mb-3">
              <v-text-field
                v-model="search"
                prepend-icon="search"
                label="Search"
                single-line
                hide-details
                style="padding: 0"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
    <v-data-table
      :headers="headers"
      :loading="is_loading"
      :items="filterContactList"
      :pagination.sync="pagination"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.index + 1 }}</td>
        <td class="text-xs-left">
          {{ props.item.contact_store_province_name.toUpperCase() }}
        </td>
        <td class="text-xs-left">
          {{
            props.item.contact_store_service_id_id == 1
              ? "Restuarant"
              : props.item.contact_store_service_id_id == 2
              ? "WeFix"
              : props.item.contact_store_service_id_id == 3
              ? "Parcel"
              : ""
          }}
        </td>
        <td class="text-xs-left">{{ props.item.contact_user_name }}</td>
        <td class="text-xs-left">{{ props.item.contact_store_name_th }}</td>
        <td class="text-xs-left">{{ props.item.contact_store_address }}</td>
        <td class="text-xs-left">
          {{ props.item.contact_email || props.item.contact_user_email }}
        </td>
        <td class="text-xs-left">{{ props.item.contact_user_tel }}</td>
        <td class="text-xs-left">
          {{ moment(props.item.crate_at).format("MMMM Do YYYY, HH:mm:ss") }}
        </td>
        <td class="text-xs-center">
          <v-btn
            flat
            style="background-color: #fddf00; color: black"
            @click="toApproveContactRes(props.item)"
            >see more</v-btn
          >
        </td>
      </template>
      <template slot="no-data">
        <div v-if="filterContactList.length == 0 && is_loading == false">
          No data available
        </div>
        <div v-else>
          <v-progress-circular
            :size="30"
            color="primary"
            indeterminate
          ></v-progress-circular>
          {{ "Loading data ..." }}
        </div>
      </template>
    </v-data-table>
    
    <approveContactDialog
      @setDialog="contactDialog = $event"
      :dialog="contactDialog"
      :selected_item="selected_item"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import approveContactDialog from "@/components/back-office/Merchant/ContactApprove/ApproveContactDialog.vue";
import moment from "moment";
export default {
  data: () => ({
    documentDialog: false,
    provinceList: ["All"],
    is_loading: false,
    contactDialog: false,
    search: "",
    selected_item: {
      contact_id: null,
      contact_store_tel: "",
      contact_store_address: "",
      contact_store_name_th: "",
      contact_store_service_id_id: null,
      contact_store_province_id: null,
      contact_store_province_name: null,
      contact_us_id_id: null,
      contact_user_id_id: null,
      contact_user_name: "",
    },
    pagination: {
      rowsPerPage: 10,
      page: 1,
      totalItems: 0,
    },
    headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
      },
      {
        text: "Province",
        align: "center",
        value: "contact_store_province_name",
        sortable: false,
      },
      {
        text: "Service name",
        align: "center",
        value: "contact_store_service_id_id",
        sortable: false,
      },
      {
        text: "User name",
        align: "center",
        value: "contact_user_name",
        sortable: false,
      },
      {
        text: "Store name",
        align: "center",
        value: "contact_store_name_th",
        sortable: false,
      },

      {
        text: "Store address",
        align: "center",
        value: "contact_store_address",
        sortable: false,
      },
      {
        text: "OWNER E-mail",
        align: "center",
        value: "contact_store_tel",
        sortable: false,
      },
      {
        text: "OWNER Tel.",
        align: "center",
        value: "contact_store_tel",
        sortable: false,
      },
      {
        text: "Request Date/Time",
        align: "center",
        value: "contact_store_tel",
        sortable: false,
      },
      {
        text: "",
        align: "center",
        value: "",
        sortable: false,
      },
    ],
  }),
  components: {
    approveContactDialog,
  },
  computed: {
    ...mapState({
      contact_store_approve_list: (state) =>
        state.fetchStoreApproveBack.contact_store_approve_list,
    }),
    filterContactList() {
      if (this.search == "") {
        return this.contact_store_approve_list;
      }
      return this.contact_store_approve_list.filter(
        (el) =>
          el.contact_store_province_name
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          el.contact_user_name
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          el.contact_store_name_th
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          el.contact_store_address
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          el.contact_user_email
            .toLowerCase()
            .includes(this.search.toLowerCase()) ||
          el.contact_user_tel.toLowerCase().includes(this.search.toLowerCase())
      );
    },
  },
  watch: {},
  created() {
    this.fetchData();
  },
  methods: {
    moment,
   
    toApproveContactRes(item) {
      this.selected_item = item;
      this.contactDialog = true;
    },
    async fetchData() {
      this.is_loading = true;

      await this.$store.dispatch("fetchStoreApproveBack/getContactApproveList");
      let provinceData = await this.$store.dispatch(
        "fetchProvinceBack/getData"
      );
      this.provinceList = [
        "All",
        ...provinceData.map((el) => el.province_name_en.toUpperCase()),
      ];
      this.is_loading = false;
    },
  },
};
</script>

<style scoped>
.popular_toggle {
  position: absolute;
  top: 13px;
  left: 40%;
}
.approve-btn {
  font-size: 13px;
  background-color: green;
  padding: 5px;
  border-radius: 3px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}
.onhold-btn {
  font-size: 13px;
  background-color: orange;
  padding: 5px;
  border-radius: 3px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}
.reject-btn {
  font-size: 13px;
  background-color: red;
  padding: 5px;
  border-radius: 3px;
  color: white;
  margin: 5px;
  box-shadow: 0 2px 3px 0 rgba(0, 0, 0, 0.2), 0 1px 1px 0 rgba(0, 0, 0, 0.19);
}
</style>


